import FindAgent from './FindAgent';

document.addEventListener('DOMContentLoaded', () => {
  new FindAgent();
});
